import React, { Fragment } from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { SharedDocument } from '../../../documents/sharedDocument';

const DownloadDocumentButton = ({
  onClick,
  documentId,
  documentIdDownloading,
}) => {
  const isDownloading = documentId === documentIdDownloading;
  return (
    <Button
      title={isDownloading ? 'Downloading' : 'Download Document'}
      className="btn btn-outline-primary"
      onClick={onClick}
    >
      {isDownloading && <i className="fa fa-spin fa-spinner" />}
      {!isDownloading && <i className="fa fa-download" />}
    </Button>
  );
};

const Document = ({ document, onDownloadDocument, documentIdDownloading }) => {
  return (
    <li
      className="list-group-item document-item"
      key={document.sharedDocumentId}
    >
      <div className="flextable">
        <div className="flextable-item flextable-primary">
          {document.sharedDocumentName}
        </div>
        <div className="flextable-item">
          <ButtonGroup>
            <DownloadDocumentButton
              onClick={onDownloadDocument}
              documentIdDownloading={documentIdDownloading}
              documentId={document.sharedDocumentId}
            />
          </ButtonGroup>
        </div>
      </div>
    </li>
  );
};

class QuoteSharedDocumentsListComponent extends React.PureComponent {
  static propTypes = {
    documents: PropTypes.array.isRequired,
  };

  state = {
    documentIdDownloading: null,
  };

  downloadDocument(document) {
    this.setState({ documentIdDownloading: document.sharedDocumentId });
    SharedDocument.download(
      document.sharedDocumentId,
      document.currentVersion
    ).finally(() => this.setState({ documentIdDownloading: null }));
  }

  render() {
    const { documents } = this.props;
    const { documentIdDownloading } = this.state;

    return (
      <Fragment>
        <div className="option-set-form">
          <ul className="list-group list-group-flush">
            {documents.map((document) => {
              return (
                <Document
                  key={document.sharedDocumentId}
                  document={document}
                  onDownloadDocument={() => this.downloadDocument(document)}
                  documentIdDownloading={documentIdDownloading}
                />
              );
            })}
          </ul>
          {documents.length === 0 && (
            <div className="row">
              <div className="col text-center">No documents found</div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default withRouter(QuoteSharedDocumentsListComponent);
